export default {
  LOADING: (state: IAssetState) => {
    return state.loading;
  }
};
